import { gql } from '@apollo/client';

export default gql`
  mutation connectGoogleDrive($code: String!, $redirectUri: String!) {
    connectGoogleDrive(
      input: { code: $code, redirectUri: $redirectUri }
    ) {
      storageProvider {
        id
        providerType
        active
        expiresAt
        tokenExpired
      }
    }
  }
`;
